import React from 'react';
import { FoodPhoto } from '../FoodPhoto';
export function FoodPhoto5() {
  return <FoodPhoto src="https://images.unsplash.com/photo-1547592180-85f173990554?w=1200&q=85" alt="Beautifully plated grilled chicken with roasted vegetables" caption="Herb-roasted chicken breast with sweet potato and steamed broccoli" data-id="element-465" />;
}